import React, {Component} from 'react';
import {action, observable} from 'mobx';
import {inject, observer} from 'mobx-react';
import _ from "underscore";
import {
  Modal,
  ModalBody,
  FormGroup,
  FormInput,
  Button,
  FormCheckbox
} from "shards-react";
//https://designrevision.com/docs/shards-react/getting-started
import 'react-calendar/dist/Calendar.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



import './style.scss'

import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import moment from "moment";
import ModalLoading from "../../../components/common/ModalLoading";

let initSetting = {
  writer: '',
  password: '',
  isAutoWrite: false,
  isShowWriterName:  false,
  isShowProductName: false,
  sentencesNum: '2~3',
  autoReplyStartTime: 9,
  autoReplyEndTime: 18,
  autoReplyFrequency: 3,
  autoRunTimes: [],
  atmosphere: ['', '', ''],
  reviewRatingConfigs: [
    { isAutoWrite: true, rating: '1_20', type: 'na', isShowWriterName:false, isShowProductName: false, tone: ''},
    { isAutoWrite: true, rating: '21_40', type: 'fixed', isShowWriterName:false, isShowProductName: false, tone: '안녕하세요. [구매자명]님. [상품명]리뷰 작성 감사합니다. \n' +
          '[상품별 추가 내용]' +
          '고객님의 소중한 리뷰는 저희에게 큰 힘이 됩니다. 앞으로도 더욱 좋은 상품으로 보답하겠습니다.'},
    { isAutoWrite: true, rating: '41_100', type: 'ai', isShowWriterName:true, isShowProductName: true, tone: '안녕하세요. 고객님. 리뷰 작성 감사합니다. 고객님의 소중한 리뷰는 저희에게 큰 힘이 됩니다. 앞으로도 더욱 좋은 상품으로 보답하겠습니다.'},
  ]
}

const FILTERWORDS = [
  { block: "씨발", alter: "**" },
  { block: "시발", alter: "**" },
  { block: "씨발놈", alter: "**" },
  { block: "시발년", alter: "**" },
  { block: "개새끼", alter: "**" },
  { block: "좆", alter: "**" },
  { block: "좆같다", alter: "**" },
  { block: "병신", alter: "**" },
  { block: "씹새끼", alter: "**" },
  { block: "염병", alter: "**" },
  { block: "뒤져라", alter: "**" },
  { block: "좆나", alter: "**" },
  { block: "썅년", alter: "**" },
  { block: "미친년", alter: "**" },
  { block: "미친놈", alter: "**" },
  { block: "지랄", alter: "**" },
  { block: "좆밥", alter: "**" },
  { block: "뻑큐", alter: "**" },
  { block: "뒤졌다", alter: "**" },
  { block: "시펄", alter: "**" },
  { block: "씨팔", alter: "**" },
  { block: "섹스", alter: "**" },
  { block: "나체", alter: "**" },
  { block: "자위", alter: "**" },
  { block: "fuck", alter: "**" },
  { block: "shit", alter: "**" },
  { block: "asshole", alter: "**" },
  { block: "bitch", alter: "**" },
  { block: "bastard", alter: "**" },
  { block: "cunt", alter: "**" },
  { block: "dick", alter: "**" },
  { block: "pussy", alter: "**" },
  { block: "slut", alter: "**" },
  { block: "whore", alter: "**" },
  { block: "motherfucker", alter: "**" },
  { block: "faggot", alter: "**" },
  { block: "nigger", alter: "**" },
  { block: "hentai", alter: "**" },
  { block: "porn", alter: "**" },
  { block: "blowjob", alter: "**" },
  { block: "handjob", alter: "**" },
  { block: "anal", alter: "**" },
  { block: "rape", alter: "**" },
  { block: "tits", alter: "**" },
  { block: "cock", alter: "**" },
  { block: "cum", alter: "**" },
  { block: "jerk off", alter: "**" },
  { block: "dumbass", alter: "**" },
  { block: "idiot", alter: "**" },
  { block: "scum", alter: "**" }
];

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

@inject(({ common }) => ({ getStoreTotalConfig: common.getStoreTotalConfig, updateDoc: common.updateDoc, getDoc: common.getDoc }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me }))
@inject(({ company }) => ({ updateStore:company.updateStore, getApplySkins:company.getApplySkins, applyAllSkin:company.applyAllSkin, applySkin:company.applySkin}))
@inject(({ product }) => ({ getProductList: product.getProductList, setProductSync: product.setProductSync }))
@inject(({ review }) => ({ setReviewSync: review.setReviewSync, getStatusReviewBoard: review.getStatusReviewBoard }))

@observer
class ReviewFilter extends Component {

  //basic
  @observable teamUser = {};
  @observable permissions = {}
  @observable store = {};
  @observable isUse = {};
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = false;

  //page
  //카테고리 정보와 상품 정보 샵에서 가져와야함.
  @observable setting = initSetting;
  @observable skins = [];
  @observable syncReviewValue = {
    startDate: moment().add(-1, 'days').format('yyyy-MM-DD'),
    endDate: moment().format('yyyy-MM-DD'),
    isOverwrite: false,
  };

  @observable reviewWrightLimit = {
    store_id: null,
    isUseNormalReview: true,
    // isUseSnsReview: false,
    isUseNoPurchase: false,
  }

  @observable basicSettings = {
    store_id: null,
    minChars: 10,
    maxChars: 5000,
    mainPhase: [],
    subPhase: [],
    writeEnabledState: 1,
    writeEnabledDate: 50,
    isDeliveryRating: false
  };

  @observable serarchPeriod = [3, "months", "3개월 단위"];
  @observable newMainPhase = '';
  @observable newSubPhase = '';

  @observable reviewFiltering = {
    store_id: null,
    isRecmFilter: false,
    filterWords: []
  };
  // @observable isRecmFilter = {
  //   isUse: false
  // }

  @observable filterWords = [];
  @observable newFilterWord = { block: '', alter: ''};

  //modals
  @observable isWidgetMode = false;
  @observable isShowCalendar = {
    startDate: false,
    endDate: false
  }
  @observable isShowCalendarForRS = {
    startDate: false,
    endDate: false
  }
  @observable modals = {
    cafeSettingData: {},
    isCafeSettingModal: false
  };

  // @observable reviewAutoReply = {
  //   store_id: null,
  //   isUse: false,
  //   displayTime: 30,
  //   replyContents: []
  // }

  // @observable newReplyContents = {
  //   grade: null,
  //   text: ''
  // };

  constructor(props) {
    super(props);
    this.init()

    // this.onChangeInputs = this.onChangeInputs.bind(this);
    // this.onChangeChecked = this.onChangeChecked.bind(this);
    // this.updateFilter = this.updateFilter.bind(this);
  }


  @action
  init = async (key) => {
    let _this = this;
    if(this.props.isLogin) {
      //basic
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.teamUser.store;
      this.isUse = false;
      if(this.teamUser.isPaidShop) {
        this.isUse = true;
      }
      this.permissions = this.props.me.permissions;

      this.props.getStoreTotalConfig({store_id: this.teamUser.selStore_id, shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1}, function(res) {
      // this.props.getStoreTotalConfig({store_id: this.teamUser.selStore_id}, function(res) {
        if(res.errors && res.errors.length > 0) {
          alert(res.errors[0].message);
        }
        else {
          let results;
          if(res) {
            results = res;
            if(results.basicSettings) {
              let getSettings = _.pick(results.basicSettings, 'writer', 'password', 'replyTyep', 'store_id', 'minChars', 'maxChars', 'mainPhase', 'subPhase', 'writeEnabledState', 'writeEnabledDate', 'isDeliveryRating', 'productReviewInfoType');
              _this.basicSettings = {..._this.basicSettings , ...getSettings};
            }
            if(results.filtering) {
              _this.reviewFiltering = results.filtering;
              _this.filterWords = results.filtering.filterWords;
            }
            if(results.writeLimit) {
              _this.reviewWrightLimit = results.writeLimit;
            }
            _this.basicSettings.store_id = _this.teamUser.selStore_id;
            _this.reviewFiltering.store_id = _this.teamUser.selStore_id;
            _this.reviewWrightLimit.store_id = _this.teamUser.selStore_id;

            _this.basicSettings.shopNo = _this.teamUser.selShopNo;
            _this.reviewFiltering.shopNo = _this.teamUser.selShopNo;
            _this.reviewWrightLimit.shopNo = _this.teamUser.selShopNo;
          }
        }
      });

      this.getApplySkins(false);

    }
  };

  onChangeInputs = async (event, targetObj) => {
    let { name, value } = event.target;
    let isPrg = true;
    if(targetObj) {
      if(name === 'writeEnabledDate') {
        if(value > 0 && value < 60) {

        }
        else {
          if(value === '' || value === null) {
            value = '';
          }
          else {
            alert('최소 1, 최대 60일까지 가능합니다.')
            isPrg = false;
            console.log(value, typeof value)
          }

        }
      }
      if(isPrg) {
        targetObj[name] = value;
        if(name === "cafe24UseReviewBoardNo") {
          let updateStore = {
            id: this.teamUser.store._id,
            cafe24UseReviewBoardNo: parseInt(value)
          }
          this.props.updateStore( updateStore, function(res) {
            if(res.errors && res.errors.length > 0) {
              toast(res.errors[0].message);
            }
            else {
              toast('업데이트가 완료 되었습니다.');
            }
          });
        }
      }
    }
  };

  nullCheck = async (event, targetObj, defalutValue) => {
    let { name, value } = event.target;
    if(value === '' || value === null) {
      value = defalutValue;
    }
    targetObj[name] = value;
  }

  onChangeChecked = async (event, targetObj, keyArray) => {
    if(keyArray[0]) {
      targetObj[keyArray[0]] = !targetObj[keyArray[0]];
      if(keyArray[0] === 'isSetScript') {
        targetObj.id = targetObj._id;

        this.props.applySkin(targetObj, function(res) {
          if(res.errors && res.errors.length > 0) {
            alert(res.errors[0].message);
            targetObj[keyArray[0]] = !targetObj[keyArray[0]];
          }
          else {
            console.log(res)
            toast('처리 되었습니다.');
            //targetObj[keyArray[0]] = !targetObj[keyArray[0]];
          }
        });
      }
      else if(keyArray[0] === 'isRecmFilter') {
        this.props.updateDoc('updateFilter', this.reviewFiltering, function(res) {
          if(res.errors && res.errors.length > 0) {
            toast(res.errors[0].message);
          }
          else {

          }
        });
      }
    }
  };

  @action
  getApplySkins = async (actSync) => {
    let _this = this;
    let updateStore = {
      store_id: this.teamUser.store._id,
      actSync: actSync
    }
    this.props.getApplySkins( updateStore, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        _this.skins = res.data;
        if(actSync) {
          toast('업데이트가 완료 되었습니다.');
        }
      }
    });
  }

  onChangeCheckedforApplySkin = async (event, targetObj, keyArray) => {
    if(this.teamUser.isPaidShop) {
      if(keyArray[0]) {
        targetObj[keyArray[0]] = !targetObj[keyArray[0]];
        if(keyArray[0] === 'isSetScript') {
          targetObj.id = targetObj._id;
          this.props.applySkin(targetObj, function(res) {
            if(res.errors && res.errors.length > 0) {
              alert(res.errors[0].message);
              targetObj[keyArray[0]] = !targetObj[keyArray[0]];
            }
            else {
              console.log(res)
              toast('처리 되었습니다.');
              //targetObj[keyArray[0]] = !targetObj[keyArray[0]];
            }
          });
        }
      }
    }
    else {
      let cf = window.confirm('무료 사용을 포함하여 주문 완료 후 이용 가능합니다. 주문 페이지로 이동하시겠습니까?');
      if(cf) {
        window.location.href = '/inAppOrder';
      }
    }

  };

  @action
  modalToggle = function(target, data) {
    let _this = this;
    this.modals[target] = !this.modals[target];
    if(!target) {
      for( var i in this.modals) {
        this.modals[i] = false;
      }
    }

    if(target === 'isCafeSettingModal') {
      // if(!this.isUse) {
      //   alert('사용권한이 없습니다.');
      //   return false;
      // }
      if(this.skins.length === 0) {
        this.getApplySkins(true);
      }
    }

    if(data) {
      if(target === 'isCafeSettingModal' && data) {
        this.modals.widgetData.product = data;
      }
      else {
        this.modals.data = data;
      }
    }

    if(target === 'isSyncReview') {

      let data = {
        store_id: this.store._id,
        flatform: 'cafe24'
      }

      this.props.getStatusReviewBoard(data, function(res) {
        if(res && res.data) {
          _this.modals.data = res.data;
          if(res.data.selectPeriod[1] === "years") {
            res.data.selectPeriod[2] = res.data.selectPeriod[0] + "년";
          }
          else if(res.data.selectPeriod[1] === "months") {
            res.data.selectPeriod[2] = res.data.selectPeriod[0] + "월";
          }
          else if(res.data.selectPeriod[1] === "weeks") {
            res.data.selectPeriod[2] = res.data.selectPeriod[0] + "주";
          }
          else if(res.data.selectPeriod[1] === "days") {
            res.data.selectPeriod[2] = res.data.selectPeriod[0] + "일";
          }
          _this.serarchPeriod = res.data.selectPeriod;
          _this.syncReviewValue.startDate = moment().add(-res.data.selectPeriod[0], res.data.selectPeriod[1]).add(1, 'days').format('yyyy-MM-DD');
        }
      });
    }

  };



  onChangeSyncReviewValue = async (event, obj) => {
    const { name, value, type } = event.target;
    console.log(name, value, type, obj)
    let newValue;
    if(type === 'checkbox') {
      if(value) {
        newValue = !JSON.parse(value);
      }
      else {
        newValue = true;
      }
    }
    else {
      newValue = value;
    }

    if(obj) {
      obj[name] = newValue;

      if(name === 'all') {
        for(let key in obj) {
          obj[key] = newValue;
        }
      }
      else {
        let isAll = false;
        if(newValue) {
          isAll = true;
          for(let key in obj) {
            if(!obj[key] && key !== 'all') {
              isAll = false;
              break;
            }
          }
        }
        obj['all'] = isAll;
      }
    }
    else {
      this.syncReviewValue[name] = newValue;
    }

  };


  onChangeCalendarValueForRS = async (date, dateType) => {
    this.isShowCalendarForRS = {
      startDate: false,
      endDate: false,
    };
    this.syncReviewValue[dateType] = moment(date).format('yyyy-MM-DD');
    // if((this.syncReviewValue.startDate || this.syncReviewValue.endDate) && !isOverPeriod(this.syncReviewValue.startDate, this.syncReviewValue.endDate, this.serarchPeriod)) {
    //   alert('최대 ' + this.serarchPeriod[2]  + '로 선택해 주세요.');
    //
    // }
  }


  updateLimits = async (event) => {
    let _this = this;

    this.props.updateDoc('updateLimits', this.reviewWrightLimit, function(res) {
      if(res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {
        _this.newFilterWord = { block: '', alter: ''};
      }
    });

  };

  addPhrase = async (event, target) => {
    if(target === 'mainPhase') {
      this.basicSettings.mainPhase.push(this.newMainPhase);
      this.newMainPhase = '';
    }
    else if(target === 'subPhase') {
      this.basicSettings.subPhase.push(this.newSubPhase);
      this.newSubPhase = '';
    }
    this.props.updateDoc('updateBasicSettings', this.basicSettings, function(res) {
      if(res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {

      }
    });
  }

  removePhrase = async (event, target, i) => {
    if(target === 'mainPhase') {
      this.basicSettings.mainPhase.splice(i, 1);
    }
    else if(target === 'subPhase') {
      this.basicSettings.subPhase.splice(i, 1);
    }
    this.props.updateDoc('updateBasicSettings', this.basicSettings, function(res) {
      if(res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {

      }
    });
  }

  // saveAutoReplyConfig = async () => {
  //   if(this.basicSettings.writer === '') {
  //     toast('답글 작성에 필요한 답글 작성자 이름을 입력해 주세요.');
  //     return;
  //   }
  //   else if(this.basicSettings.password === '') {
  //     alert('답글 작성에 필요한 비밀번호를 입력해 주세요.');
  //     return;
  //   }
  //
  //   const res = await this.props.updateDoc('updateBasicSettings', this.basicSettings);
  //   if (res.errors && res.errors.length > 0) {
  //     toast(res.errors[0].message);
  //   } else {
  //     toast('저장 되었습니다.');
  //   }
  // };

  updateBasicSetting = async (event) => {
    if(this.basicSettings.writer === '') {
      toast('답글 작성에 필요한 답글 작성자 이름을 입력해 주세요.');
      return;
    }
    else if(this.basicSettings.password === '') {
      alert('답글 작성에 필요한 비밀번호를 입력해 주세요.');
      return;
    }

    this.props.updateDoc('updateBasicSettings', this.basicSettings, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        toast('저장 되었습니다.');
      }
    });
  }

  updateFilter = async (event) => {
    let _this = this;
    if(!_this.newFilterWord.block) {
      alert("차단어를 입력해 주세요");
      return false;
    }
    if(!_this.newFilterWord.alter) {
      alert("대체어를 입력해 주세요");
      return false;
    }
    this.filterWords.push(_this.newFilterWord);
    this.reviewFiltering.filterWords = this.filterWords;

    this.props.updateDoc('updateFilter', this.reviewFiltering, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        _this.newFilterWord = { block: '', alter: ''};
      }

    });
  };

  delFilter = async (del_index, event) => {
    this.filterWords.splice(del_index, 1);

    this.reviewFiltering.filterWords = this.filterWords;

    this.props.updateDoc('updateFilter', this.reviewFiltering, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        toast('삭제 되었습니다.');
      }

    });
  };


  onDragStart = async (del_index, event) => {

  };

  onDragEnd = async (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    this.basicSettings.mainPhase = reorder(
      this.basicSettings.mainPhase,
      result.source.index,
      result.destination.index
    );
  }


  render() {

    // const reorder = (list, startIndex, endIndex) => {
    //   const result = Array.from(list);
    //   const [removed] = result.splice(startIndex, 1);
    //   result.splice(endIndex, 0, removed);
    //
    //   return result;
    // };
    //
    // const grid = 8;

    // (구) getItemStyle, getListStyle, skinLanguageCodeKR — react-beautiful-dnd 제거로 미사용

    return (
      <>
      <div className="main-content">
          <PageTitle />

          {( this.isLogin && this.teamUser.emailId ) ?
            <div className="write-post-box">

              <div className="section-box">
                <div className="substitute-table">
                  <div className="section-tit">
                    <h3><FeatherIcon icon="filter" size="18" className="section-icon"/> 리뷰 단어 필터링 설정</h3>
                    <p className="section-desc">리뷰에 포함된 특정 단어를 차단하거나 대체 단어로 변경합니다.</p>
                  </div>
                  <div className="auto-reply-use">
                    <div className="table-tit">
                      <h4>추천 필터링 사용 여부</h4>
                    </div>
                    <table className="s-table">
                      <colgroup>
                        <col width="245px"/>
                        <col width=""/>
                      </colgroup>
                      <tbody>
                      <tr>
                        <th>
                          <fieldset>
                            <FormCheckbox toggle small checked={this.reviewFiltering.isRecmFilter}
                                          onChange={event => this.onChangeChecked(event, this.reviewFiltering, ['isRecmFilter'])}>
                              추천 필터링 {this.reviewFiltering.isRecmFilter ? '사용중' : '미사용중'}
                            </FormCheckbox>
                          </fieldset>
                        </th>
                        <td>
                          온리플가 제공하는 추천 필터링을 사용하시고 필터링을 아래에 더 추가가 가능합니다. <span onClick={e => this.modalToggle('isRecmFilterModal')}>(보기)</span>
                        </td>
                        {/*<td>*/}
                        {/*  자동 답글 사용 시, 일반리뷰(SNS 리뷰 외)에 아래 내용으로 사용자 평가에 따라 랜덤하게 답글이 작성됩니다.*/}
                        {/*</td>*/}
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <table className="s-table mt-3">
                    <colgroup>
                      <col width="20px"/>
                      <col width=""/>
                      <col width=""/>
                      <col width="200px"/>
                    </colgroup>
                    <thead>
                    <tr>
                      <th>no</th>
                      <th>차단어</th>
                      <th>대체어</th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.filterWords && this.filterWords.length > 0 ?
                        this.filterWords.map((item, i) => (
                            <tr key={i}>
                              <td className="keyword-num">{i + 1}</td>
                              <td>{item.block}</td>
                              <td>{item.alter}</td>
                              <td><Button theme="warning" onClick={e => this.delFilter(i, e)}>삭제하기</Button></td>
                            </tr>
                        ))
                        :
                        null
                    }
                    <tr>
                      <td>+</td>
                      <td><FormGroup><FormInput value={this.newFilterWord.block} name="block" className="text-center"
                                                onChange={event => this.onChangeInputs(event, this.newFilterWord)}
                                                placeholder="차단어를 입력해 주세요."/></FormGroup></td>
                      <td><FormGroup><FormInput value={this.newFilterWord.alter} name="alter" className="text-center"
                                                onChange={event => this.onChangeInputs(event, this.newFilterWord)}
                                                placeholder="대체어를 입력해 주세요."/></FormGroup></td>
                      <td><Button theme="primary" onClick={e => this.updateFilter(e)}>추가하기</Button></td>
                    </tr>
                    </tbody>
                  </table>
                  {/*<div className="btn-save">*/}
                  {/*  <Button className="save-button" onClick={event => this.updateReplyContent(event)}>저장</Button>*/}
                  {/*</div>*/}
                </div>
              </div>

              <Modal size="lg" className='modal-recm-filter' open={this.modals.isRecmFilterModal}
                     toggle={() => {}} centered={true}>
                <ModalBody className="history-window-popup">
                  {/*<ModalHeader>온리플 추천 필터링</ModalHeader>*/}
                  {/*<p><span className='warning-font'>* 해당 리뷰작성에 대한 책임은 작성자 또는 작성자가 속한 회사에 책임이 있습니다.</span></p>*/}
                  <div className="history-popup-contents">
                    <div className="popup-contents-main">
                      <h4>온리플 추천 필터링</h4>
                      <table className="s-table">
                        <colgroup>
                          <col width="20px"/>
                          <col width=""/>
                          <col width=""/>
                        </colgroup>
                        <thead>
                        <tr>
                          <th>no</th>
                          <th>차단어</th>
                          <th>대체어</th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {FILTERWORDS && FILTERWORDS.length > 0 ?
                            FILTERWORDS.map((item, i) => (
                                <tr key={i}>
                                  <td className="keyword-num">{i + 1}</td>
                                  <td>{item.block}</td>
                                  <td>{item.alter}</td>
                                </tr>
                            ))
                            :
                            null
                        }
                        </tbody>
                      </table>
                    </div>


                    <div className="text-center">
                      {/*<Button onClick={event => this.updateReview(this.modals.widgetData)}>리뷰작성</Button>*/}
                      <Button className="ml-2" theme="light"
                              onClick={event => this.modals.isRecmFilterModal = false}>닫기</Button>
                    </div>
                  </div>

                </ModalBody>
              </Modal>



              <ModalLoading isLoading={this.isLoading}/>
            </div>
            :
            null
          }
        </div>


      </>
    )
  }
}

export default ReviewFilter;
